import React from 'react';

import FlexBox from '@/components/FlexBox';
import Layout from '@/components/Layout';
import Typography from '@/components/Typography';

const NotFound = (): JSX.Element => {
  return (
    <Layout>
      <FlexBox variant='center' classes={['flex-col', 'items-center', 'h-content']}>
        <Typography variant='title'>ページが見つかりません</Typography>
        <Typography variant='body'>お探しのページは、移動または削除された可能性があります。</Typography>
      </FlexBox>
    </Layout>
  );
};

export default NotFound;
